import React, { useState, useEffect } from 'react';
import useRectificationStore from '../../stores/useRectificationStore';
import styles from './ToolCard.module.css';
import DynamicSlider from '../ui/DynamicSlider';

const BlockingZoneToolCard = () => {
  const blockingZoneState = useRectificationStore((state) => state.blockingZone);
  const setBlockingZone = useRectificationStore((state) => state.setBlockingZone);
  
  // Use local state for UI but sync with store
  const [sliderValue, setSliderValue] = useState(blockingZoneState.radius);

  // Sync with store when component mounts or store changes
  useEffect(() => {
    setSliderValue(blockingZoneState.radius);
  }, [blockingZoneState.radius]);

  const ControlButtons = () => {
    return (
    <div className='flex flex-row gap-1 h-7 my-3 px-2'>
      <button className={`w-full h-full text-white text-sm bg-red-400 rounded-sm cursor-pointer hover:bg-red-300 ${blockingZoneState.mode === 'paint' ? 'border-2 scale-105 border-gray-900' : ''}`} onClick={() => setBlockingZone({ mode: 'paint' })}>Draw</button>
      <button className={`w-full h-full text-white text-sm bg-blue-400 rounded-sm cursor-pointer hover:bg-blue-300 ${blockingZoneState.mode === 'erase' ? 'border-2 scale-105 border-gray-900' : ''}`} onClick={() => setBlockingZone({ mode: 'erase' })}>Erase</button>
      <button className={`w-full h-full text-white bg-green-400 rounded-sm cursor-pointer hover:bg-green-300`} onClick={() => setBlockingZone({ mask: null })}>Erase All</button>
    </div>
    )
  }

  const ControlButtons2 = () => {
    return (
<div
  className="w-full h-10 my-3 overflow-hidden rounded-l p-1"
  role="group"
  aria-label="Mask tools"
>
  <div className="flex h-full gap-1 w-full">
    {/* Draw */}
    <button
      type="button"
      title="Draw (paint a blocking mask)"
      aria-pressed={blockingZoneState.mode === 'paint'}
      onClick={() => setBlockingZone({ mode: 'paint' })}
      className={`group flex-1 min-w-0 inline-flex items-center justify-center gap-2 rounded-md px-2 text-xs font-medium text-white transition-all
        ring-1 ring-inset focus:outline-none
        cursor-pointer focus-visible:ring-2 focus-visible:ring-rose-400 focus-visible:ring-offset-2 focus-visible:ring-offset-neutral-900
        ${blockingZoneState.mode === 'paint'
          ? 'bg-gradient-to-b from-rose-500 to-rose-600 hover:to-rose-500 ring-white/10 shadow-sm'
          : 'bg-neutral-800/60 hover:bg-neutral-700/70 ring-white/10 hover:ring-white/20'
        }`}
    >
      <svg className="h-4 w-4 shrink-0 opacity-90 group-hover:opacity-100" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M16.862 3.487a2.5 2.5 0 1 1 3.536 3.536L8.25 19.172 4 20l.828-4.25L16.862 3.487Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M14.75 5.6l3.65 3.65" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      </svg>
      <span className="truncate">Draw</span>
    </button>

    {/* Erase */}
    <button
      type="button"
      title="Erase (remove from mask)"
      aria-pressed={blockingZoneState.mode === 'erase'}
      onClick={() => setBlockingZone({ mode: 'erase' })}
      className={`group flex-1 min-w-0 inline-flex items-center justify-center gap-2 rounded-md px-2 text-xs font-medium text-white transition-all
        ring-1 ring-inset focus:outline-none
        cursor-pointer
        focus-visible:ring-2 focus-visible:ring-sky-400 focus-visible:ring-offset-2 focus-visible:ring-offset-neutral-900
        ${blockingZoneState.mode === 'erase'
          ? 'bg-gradient-to-b from-sky-500 to-sky-600 hover:to-sky-500 ring-white/10 shadow-sm'
          : 'bg-neutral-800/60 hover:bg-neutral-700/70 ring-white/10 hover:ring-white/20'
        }`}
    >
      <svg className="h-4 w-4 shrink-0 opacity-90 group-hover:opacity-100" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M3.75 14.75 12.5 6a3 3 0 0 1 4.243 0l1.757 1.757a3 3 0 0 1 0 4.243L10.25 21H6.5a2.75 2.75 0 0 1-2.75-2.75v0Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M8.5 18.5h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      </svg>
      <span className="truncate">Erase</span>
    </button>

    {/* Erase All (destructive) */}
    <button
      type="button"
      title="Erase all (clear the entire mask)"
      onClick={() => setBlockingZone({ mask: null })}
      className="group flex-1 min-w-0 inline-flex items-center justify-center gap-2 rounded-md px-2 text-xs font-semibold text-white transition-all
        bg-gradient-to-b from-blue-300 to-blue-400 hover:to-blue-500
        ring-1 ring-inset ring-white/10 hover:ring-white/20
        cursor-pointer
        focus:outline-none focus-visible:ring-2 focus-visible:ring-rose-400 focus-visible:ring-offset-2 focus-visible:ring-offset-neutral-900"
    >
      <span className="truncate">Erase All</span>
    </button>
  </div>
</div>
    )
  }

  return (
    <div className={styles.toolCard}>
      <div className={styles.toolCardHeader}>
        <h3>Blocking Zone</h3>
        {/* <p>Configure blocking zones for the socket</p> */}
      </div>
      <ControlButtons2 />
      <DynamicSlider
        min={0.25}
        max={3}
        step={0.25}
        value={sliderValue}
        onChange={(value) => {
          setSliderValue(value);
          setBlockingZone({ radius: value });
        }}
        label='Radius'
        layout='inline'
        valueClassName='bg-gray-200'
        className='mb-2 px-2'
      />
    </div>
  );
};

export default BlockingZoneToolCard; 